/**
 * 认证管理 API
 */

import { http } from '../request';
import type { LoginParams, LoginResponse, UserParams } from '../../types/auth';

/**
 * 用户登录
 */
export function login(data: LoginParams): Promise<LoginResponse> {
  return http.post<LoginResponse>('/auth/login', data);
}

/**
 * 用户退出
 */
export function logout(): Promise<void> {
  return http.post('/auth/logout');
}

/**
 * 刷新 Token
 */
export function refreshToken(): Promise<LoginResponse> {
  // Token 由请求拦截器自动从 localStorage 添加
  return http.post<LoginResponse>('/auth/refresh');
}

/**
 * 修改当前用户密码
 */
export function updatePassword(oldPassword: string, newPassword: string): Promise<void> {
  return http.put('/system/user/password', { oldPassword, newPassword });
}
